import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  ref: null,
  page: 1,
  validateExactData: false,
  datas: {},
};

export const authSlice = createSlice({
  name: "alceeDataSasu1",
  initialState,
  reducers: {
    setRef: (state, action) => {
      state.ref = action.payload.ref;
      state.datas["ref"] = action.payload.ref;
    },
    setPage: (state, action) => {
      state.page = action.payload.page;
    },
    setDatas: (state, action) => {
      state.datas = action.payload.datas;
    },
    setValidateExactData: (state, action) => {
      state.validateExactData = action.payload.validateExactData;
    },
  },
});

export const { setRef, setDatas, setPage, setValidateExactData } = authSlice.actions;
export default authSlice.reducer;
